export const fonts = {
  primary: 'Inter',
  secondary: 'Ubuntu Mono',
};

export default fonts;
